document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-il-quantity-change]');

  if (!button) return;

  var control = button.closest('.il-quantity-control');
  var input = control && control.querySelector('input[name="quantity"]');

  if (!input) return;

  var currentValue = Number.parseInt(input.value, 10) || 1;
  var change = Number.parseInt(button.dataset.ilQuantityChange, 10) || 0;
  var minimum = Number.parseInt(input.min, 10) || 1;

  input.value = Math.max(minimum, currentValue + change);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('submit', async function (event) {
  var form = event.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  event.preventDefault();
  var submit = form.querySelector('[type="submit"]');
  var originalLabel = submit && submit.textContent;

  if (submit) {
    submit.disabled = true;
    submit.textContent = 'Adding…';
  }

  try {
    var response = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });

    if (!response.ok) throw new Error('Unable to add item');

    var cartResponse = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', {
      headers: { Accept: 'application/json' }
    });
    var cart = await cartResponse.json();

    document.querySelectorAll('[data-cart-count]').forEach(function (count) {
      count.textContent = cart.item_count;
    });

    if (submit) submit.textContent = 'Added ✓';
    form.dispatchEvent(new CustomEvent('icarus:cart-added', { bubbles: true, detail: { cart: cart } }));

    window.setTimeout(function () {
      if (!submit) return;
      submit.disabled = false;
      submit.textContent = originalLabel || 'Add to Basket';
    }, 1400);
  } catch (error) {
    if (submit) {
      submit.disabled = false;
      submit.textContent = 'Try again';
    }
  }
});
